<template>
  <div>Logout</div>
</template>

<script>
import AuthService from '@/services/AuthService.js';

export default {
    created(){
        AuthService.clearCredentials();
        AuthService.forgetUser();
        var goToLoginPage = new Promise(r => setTimeout(r,200))
        goToLoginPage.then(() => this.$router.push({name:'login'}))
        // window.location.reload();
    }
}
</script>

<style>

</style>